/* The main theme configuration for HelloSign */
export default {
  colors: {
    primary: '#1EA2D5',
    secondary: '#F7F8F9',
  },
  fontSizes: ['0.75rem', '0.85rem', '1rem', '1.25rem', '1.5rem', '2.25rem'],
};
